var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourselocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00013 6H2.00002C1.44772 6 1 6.56983 1 7.27275V11.7274C1 12.4303 1.44772 13.0001 2.00002 13.0001H9.00013C9.55242 13.0001 10.0001 12.4303 10.0001 11.7274V7.27275C10.0001 6.56983 9.55242 6 9.00013 6Z",
    fill: "#5C5C5C",
    stroke: "#5C5C5C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.50007V3.50004C3 2.83699 3.2634 2.20109 3.73225 1.73225C4.20109 1.2634 4.83699 1 5.50004 1C6.16309 1 6.79899 1.2634 7.26784 1.73225C7.73669 2.20109 8.00008 2.83699 8.00008 3.50004V5.50007",
    stroke: "#5C5C5C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourselocked);
export default __webpack_public_path__ + "static/media/Course locked.d38b4f5994384e0017935fada6dd9619.svg";
export { ForwardRef as ReactComponent };